export const h = {
	quantity: "庫存",
	brand: "品牌",
	sku: "SKU",
	model: "型號",
	addCart: "加入購物車",
	buyNow: "立即購買",
	productDetail: "商品詳情",
	attribute: "屬性",
	quantityExits: "有貨",
	quantityNone: "缺貨",

	// 账单页面
	email: "郵箱",
	errorEmail: "請輸入正確郵箱",
	contact: '聯絡方式',

	sippingAddress: '配送地址',
	name: "姓名",
	nameError: "請輸入姓名",
	address1: "地址1",
	address1Error: "請輸入地址1",

	address2: "地址2",
	emailCode: "郵編",

	phone: "手機號碼",
	city: "城市",
	cityError: "請輸入城市",
	country: "國家",
	countryError: "請輸入國家",
	province: "省份",
	provinceError: "請輸入省份",
	payWay: "支付方式",
	sendWay: "配送方式",
	loginText: "登入 / 註冊",
	cartNum: "購物車總數",
	orderRemarks: "訂單備註",
	discountCode: "請輸入優惠碼",
	apply: "使用",
	submitOrder: "提交訂單",


	classify: "分類",
	price: "價格",
	allNum: "總數",
	defaultTit: "默認",
	salesLowToHigh: "銷量 (低 - 高)",
	salesHighToLow: "銷量 (高 - 低)",
	nameAtoZ: "名稱 (A - Z)",
	nameZtoA: "名稱 (Z - A)",
	priceLowtoHeight: "價格 (低 - 高)",
	priceHeighttoLow: "價格 (高 - 低)",
	selectClassfiy: "選擇分類",
	goodCart: "購物車",
	checkout: "結賬",
	pay: "付款",
	goods: "商品",
	num: "數量",
	total: "小計",
	action: "操作",
	del: "刪除",
	priceTotal: "商品總計",
	all: "全部",
	selectd: "已選",
	goCheckout: "去結賬",
	linkGoods: "相關商品",
	noData: "暫無數據",
	myOrder: "我的訂單",
	changeUserInfo: "修改個人信息",
	changePassword: "修改密碼",
	myAddress: "我的地址",
	myWishlist: "我的收藏",
	myRmas: "我的售後",
	userCommission: "會員佣金",
	commissionUsers: "會員關係",
	loginOut: "退出登錄",
	orderId: "訂單號",

	lookDetail: "查看詳情",
	saleService: "申請售後",
	confirmReceivedGoods: "確認收貨",
	goPay: "去支付",
	cancelOrder: "取消訂單",

	orderDetail: "訂單詳情",
	created_at: "創建時間",
	status_format: "訂單狀態",
	total_format: "訂單金額",
	payment_method_name: '支付方式',
	shipping_method_name: '配送方式',

	addressInfo: "地址信息",
	name: "姓名",
	address: "地址",
	payGoods: "訂購商品",

	sendCompany: "快遞公司",
	sendNum: "快遞單號",
	updateTime: "更新時間",
	memo: "備註",
	payOrderAddress: "賬單地址",
	allOrder: "所有訂單",
	waitPay: "待支付",
	waitSend: "待發貨",
	waitReceiving: "待收貨",
	completed: "已完成",
	confirm: "確認",
	tips: "提示",
	cancel: '取消',
	changeHeadImg: "修改頭像",
	uploadTit: "上傳JEPG或PNG圖片。建議300 x 300。",
	imgSizeTips: "上傳頭像圖片大小不能超過 2 MB!",
	imgTypeTips: "上傳頭像圖片只能是 JPG/PNG 格式!",
	serviceType: "服務類型",
	returnNum: "退換數量",
	isOpend: "是否打開包裝",
	returnReason: "退換原因",
	yes: "是",
	no: "否",
	returnGoods: "退貨",
	exchange: "換貨",
	repair: "維修",
	reissue: "補發商品",
	refund: "僅退款",
	returnNumError: "請輸入退換數量",

	oldPassword: "舊密碼",
	newPassword: "新密碼",
	confirmNewPassword: "確認新密碼",

	wishlist: "取消收藏",
	look: "查看",
	opendPkg: "已打開包裝",
	img: "圖片",
	afterSales: "售後詳情",

	balance: "可用餘額",
	waitAmount: "待結算金額",
	withdrawaled: "已提現",
	withdrawal: "提現",
	allCommission: "總佣金",
	startTime: "開始時間",
	endTime: "結束時間",
	search: "搜索",

	rebateLevel: "返佣層級",
	CommissionRate: "佣金比例",
	commission: "佣金",
	settlementStatus: "結算狀態",
	time: "時間",
	WithdrawalAmount: "提現金額",
	peleaseSelect: "請選擇",
	withdrawalUser: "提現賬戶",
	peleaseIpt: "請輸入內容",
	submitSuccess: "提交成功",
	submitSuccess: "提交成功",
	shareLink: "分享鏈接",
	superior: "我的直屬上級",
	wu: "無",
	subordinate: "我的下級",
	addTime: "加入時間",
	userAccount: "賬號",
	recommendationCode: "推薦碼",
	copySuccess: "複製成功",
	subPay: "提交支付",
	iptCardholder_Name: "請輸入cardholder_Name",
	copy: "複製",

	"home": "首頁",
	"categoriesPage": "分類",
	"brandsPage": "品牌",
	"brandsPageList": "品牌商品",
	"productsPage": "商品",
	"wishlistPage": "我的收藏",
	"accountPage": "我的訂單",
	"cartsPage": "購物車",
	"checkoutPage": "結賬",
	"passwordPage": "修改密碼",
	"editPage": "修改信息",
	"addressesPage": "修改地址",
	"rmasPage": "會員關係",
	"commissionPage": "會員佣金",
	"success_order_checkoutPage": "訂單支付",
	"page_categoriesPage": "文章分類",
	"userloginPage": "登錄",
	"pagesPage": "文章",

	hotGoods: "熱門商品",
	newGoods: "最新商品",
	visitGoods: "瀏覽最多",
	allGoods: "所有商品",
	evaluation: "評價",

	"first_name": "姓氏",
	"first_nameError": "請輸入姓氏",
	"last_name": "名字",
	"last_nameError": "請輸入名字",

	"comment": "內容",
	"noContent": "暫無評論",
	"author": "作者",
	"scoreNum": "評分",
	"commentTit": "評論",
	send: "傳送",

	noPayWay: "無可用支付方式",
	noTransportation: "無可用運輸方式",

	"tkyouorder": "感謝您的訂購",
	"orderDate": "訂單日期",
	"ordeAmount": "訂單金額",
	"paymentAddress": "付款地址",
	"zipCode": "郵遞區號",

	customizationFee: "自訂費用"
}